import { useContext, useEffect, useMemo, useState } from "react";
import { Dropdown, Grid } from "semantic-ui-react";
import { Header } from "src/containers";
import { HoldingApp } from "./HoldingModule/HoldingApp";
import pepperIcon3 from "../../assets/svg/Pepper/Logo_Pepper_2022.svg"
import "../../containers/Header.scss"
import { CustomDropdown } from "./components/CustomDropdown";
import { CompanyContext } from "src/context";
import { useDispatch, useSelector } from "react-redux";
import { GetCompaniesData } from "src/graphql/holding";
import LoadingSpinner from "../general/js/spinnerLoading";
import { setCompaniesHoldingOptions } from "src/redux/actions/companiesHoldin";

export const Holding = (props) => {

  const dispatch = useDispatch()
  const [tokenWasObtained, setTokenWasObtained] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [companies, setCompanies] = useState([]);

  const { data: findCompaniesByIds } = GetCompaniesData({ ids: companies })

  useEffect(() => {
    const handleMessage = (event) => {

      if (!event.data || !event.data.type) return; //NO BORRAR BUCLE INFINITO

      if (event.data.type === "INIT_COMPLETE") {
        setTokenWasObtained(true);
        return;
      }

      if (!tokenWasObtained) {
        if (event.data.type === "SET_TOKEN" && event.data.token) {
          localStorage.setItem("token", event.data.token);
        }
        if (event.data.type === "SET_USER" && event.data.user) {
          localStorage.setItem("user", event.data.user);
        }
        if (event.data.type === "SET_PERSIST_ROOT" && event.data.persistRoot) {
          localStorage.setItem("persist:root", event.data.persistRoot);
        }
        if (event.data.type === "HOLDING_COMPANIES" && event.data.holdingCompanies) {
          localStorage.setItem('holdingCompanies', JSON.stringify(event.data.holdingCompanies));
          const storedData = localStorage.getItem('holdingCompanies');
          const parsedHoldingCompanies = JSON.parse(storedData) || [];
          setCompanies(parsedHoldingCompanies)
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [tokenWasObtained]);


  const {
    optionsDropdown = {}
  } = useMemo(() => {
    if (!findCompaniesByIds) return {}

    const companiesArray = findCompaniesByIds?.findCompaniesByIds || [];
    const options = companiesArray?.map(company => ({
      key: company.id,
      text: company.name,
      value: company.id
    }));

    if (options.length > 0) {
      dispatch(setCompaniesHoldingOptions(options));
    }


    return {
      optionsDropdown: options
    }

  }, [findCompaniesByIds])


  const companiesHoldingState = useSelector(state => state.companiesHolding);

  const companyList = optionsDropdown && optionsDropdown.length > 0 ?
    optionsDropdown
    :
    companiesHoldingState.companiesOptions || []



  useEffect(() => {
    if (companyList.length > 0 && selectedCompanies.length === 0) {
      setSelectedCompanies(companyList.map(company => company.value));
    }
  }, [companyList]);

  return (
    <>
      {
        !companyList.length > 0 ?
          <div className="tw-bg-gray-200 tw-min-h-screen tw-h-auto tw-flex tw-items-center tw-justify-center tw-px-10">
            <div className="tw-bg-white tw-rounded-md tw-h-[90vh] tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-10">
              <LoadingSpinner
                height="55px"
                afterHeight="55px"
                afterWidth="55px"
              />
            </div>
          </div>
          :
          <body className="tw-bg-gray-200 tw-min-h-screen tw-h-auto">
            <div className="tw-w-full tw-h-[55px] tw-bg-white tw-fixed tw-p-2 tw-flex tw-gap-4 tw-z-50">
              <div>
                <img
                  src={pepperIcon3}
                  alt="pepperIcon"
                  style={{
                    width: "40px",
                    height: "40px",
                  }}
                />
              </div>
              <div>
                <CustomDropdown
                  options={companyList}
                  value={selectedCompanies}
                  onChange={(e, { value }) => setSelectedCompanies(value)}
                />
              </div>
            </div>

            <div className="tw-px-12 tw-py-7 tw-mt-10">
              <HoldingApp
                selectedCompanies={selectedCompanies}
              />
            </div>

          </body>
      }
    </>
  )
}
